module.exports = __webpack_public_path__ + "static/rurality-371e59849afca183e5bb3fdee6c77b18.png";